var t = function(n) {
  return typeof n == "object" && n !== null && "then" in n && typeof n.then == "function";
};
export {
  t as isThenable
};
//# sourceMappingURL=index61.js.map
